// src/router/index.js
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/home.vue'
import index from '@/views/index.vue'
import Login from '@/views/login.vue'
import register from "@/views/register.vue"
import NotFound from '@/views/NotFound.vue'
import KnowledgeBase from '@/views/knowledgeBase.vue'
import drynessPathology from '@/views/drynessPathology.vue'
import dietaryGuidance from '@/views/dietaryGuidance.vue'
import caseInformation from '@/views/caseInformation.vue'
import personalInformation from '@/views/personalInformation.vue'
import evaluationDetails from '@/views/evaluationDetails.vue'
import knowledgeDetails from "@/views/knowledgeDetails.vue"
import addCase from "@/views/addCase.vue"
import caseDetails from "@/views/caseDetails.vue"
import agreement from "@/views/agreement.vue"

Vue.use(VueRouter)

const routes = [{
		path: '/',
		redirect: '/index/home'
	}, {
		path: '/index',
		name: 'index',
		component: index,
		meta: {
			requiresAuth: true
		},
		children: [{
				path: '/index/home',
				name: 'Home',
				component: Home,
			}, {
				// 中医知识库
				path: '/knowledgeBase',
				name: 'knowledgeBase',
				component: KnowledgeBase,
			}, {
				// 中医知识库
				path: '/knowledgeDetails',
				name: 'knowledgeDetails',
				component: knowledgeDetails,

			}, {
				// 燥症诊断
				path: '/drynessPathology',
				name: 'drynessPathology',
				component: drynessPathology,
				children: [{
					path: '/evaluationDetails',
					component: evaluationDetails
				}]

			}, {
				// 饮食指导
				path: '/dietaryGuidance',
				name: 'dietaryGuidance',
				component: dietaryGuidance
			},
			{
				// 病例信息
				path: '/caseInformation',
				name: 'caseInformation',
				component: caseInformation
			},
			{
				// 病例详情
				path: '/caseDetails',
				name: 'caseDetails',
				component: caseDetails
			},
			{
				// 添加病例
				path: '/addCase',
				name: 'addCase',
				component: addCase
			},
			{
				// 个人信息
				path: '/personalInformation',
				name: 'personalInformation',
				component: personalInformation
			}
		]
	},
	// {
	// 	path: '/home',
	// 	name: 'Home',
	// 	component: Home,
	// 	// meta: {
	// 	// 	requiresAuth: true
	// 	// }
	// },

	{
		path: '/agreement',
		name: 'agreement',
		component: agreement
	},
	{
		path: '/login',
		name: 'Login',
		component: Login
	},
	{
		path: '/register',
		name: 'register',
		component: register
	},
	{
		path: '*',
		name: '404',
		component: NotFound
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
	return VueRouterPush.call(this, to).catch(err => err)
}

export default router